module.exports = __webpack_public_path__ + "img/login__img.a72f192e.png";